import { fetchEditorPage } from 'client/api/pageApi'
import { EditorPageDto } from 'src/server/dto/page-content.dto'
import { BaseQueryWithValidationClass } from './utils/query-with-validation-class'

export type WebsitePagesContentCache = Record<number, EditorPageDto>

class WebsitePageContentQueryClass extends BaseQueryWithValidationClass<
  [number, number | undefined],
  EditorPageDto
> {
  queryFn = (pageId: number, layoutPageId: number | undefined) =>
    fetchEditorPage(pageId, layoutPageId) as Promise<EditorPageDto>
  getQueryKey = () => ['website-pages-content'] as const
}

export const websitePageContentQuery = new WebsitePageContentQueryClass()
